import { Button, Drawer } from '@/ui/components'
import { memo } from 'react'

const showDebug = false

const DebugSection = ({
  section,
  children
}: {
  section: any
  children: React.ReactNode
}) => {
  if (!showDebug) {
    return children
  }

  return (
    <div className="relative">
      <div className="absolute bottom-0 left-0 z-50">
        <Drawer.Root>
          <Drawer.Trigger asChild>
            <Button variant="primary" size="s">
              Open API Code
            </Button>
          </Drawer.Trigger>
          <Drawer.Content className="bg-neutral-800">
            <div className="overflow-y-auto p-4" data-lenis-prevent>
              <Drawer.Title className="mb-4 text-white">
                Component: {section.type}
              </Drawer.Title>
              <Drawer.Description></Drawer.Description>
              <div className="text-xs text-white">
                <pre
                  dangerouslySetInnerHTML={{
                    __html: JSON.stringify(section, null, 2)
                  }}
                ></pre>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Root>
      </div>
      {children}
    </div>
  )
}

export default memo(DebugSection)
